/**
 * Push notification API client
 */
import { apiFetch } from './client';

export async function getVapidPublicKey(): Promise<string> {
  return apiFetch<string>('/push/vapid-public-key');
}

interface PushSubscriptionData {
  endpoint?: string | null;
  keys?: Record<string, string> | null;
}

export async function subscribeToPush(subscription: PushSubscriptionData): Promise<void> {
  if (!subscription.endpoint || !subscription.keys?.p256dh || !subscription.keys?.auth) {
    throw new Error('Invalid subscription');
  }
  await apiFetch('/push/subscribe', {
    method: 'POST',
    body: JSON.stringify({
      endpoint: subscription.endpoint,
      keys: { p256dh: subscription.keys.p256dh, auth: subscription.keys.auth },
    }),
  });
}

export async function unsubscribeFromPush(endpoint: string): Promise<void> {
  await apiFetch('/push/unsubscribe', {
    method: 'POST',
    body: JSON.stringify({ endpoint }),
  });
}
